import { useState } from "react";
import { Box, Button, Card, CardContent, CircularProgress, TextField, Typography, Alert, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { authService } from "../services/authService";

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!username || !password) return;
    setLoading(true);
    setError(null);
    try {
      await authService.login(username, password);
      navigate("/Dashboard", { replace: true });
    } catch {
      setError("Kullanıcı adı veya şifre hatalı.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: "#f0f2f5" }}>
      <Card sx={{ width: 380, borderRadius: 3, boxShadow: 3 }}>
        <CardContent sx={{ p: 4 }}>
          <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
            <Box component="img" src="/sensify-iot.png" alt="Sensify IoT" sx={{ height: 48 }} />
          </Box>
          <Typography variant="h6" fontWeight={600} textAlign="center" mb={3} color="#1a1a1a">
            Giriş Yap
          </Typography>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Box component="form" onSubmit={handleLogin} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Kullanıcı Adı"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              fullWidth
              size="small"
            />
            <TextField
              label="Şifre"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              fullWidth
              size="small"
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              disabled={loading || !username || !password}
              sx={{ mt: 1, py: 1.2, textTransform: "none", fontWeight: 600, backgroundColor: "var(--color-primary, #1976d2)" }}
            >
              {loading ? <CircularProgress size={20} sx={{ color: "#fff" }} /> : "Giriş Yap"}
            </Button>
            <Box sx={{ textAlign: "center", mt: 1 }}>
              <Link
                component="button"
                type="button"
                variant="body2"
                onClick={() => navigate("/forgot-password")}
                underline="hover"
                sx={{ color: "text.secondary", cursor: "pointer" }}
              >
                Şifremi Unuttum
              </Link>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Login;
